__cw__define(['jquery', 'matchHeight', 'popover', 'ia-tooltip', 'liens-sociaux', 'jquery-ui-easing', 'lazy-images', 'whatinput'], function ($, matchHeight, popover, tooltip, liensSociaux) {
  function getScrollbarWidth() {
    if ($(document.body).height() <= $(window).height()) {
      return 0;
    }
    var outer = document.createElement('div');
    var inner = document.createElement('div');
    var widthNoScroll;
    var widthWithScroll;
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    document.body.appendChild(outer);
    widthNoScroll = outer.offsetWidth;

    // Force scrollbars
    outer.style.overflow = 'scroll';

    // Add inner div
    inner.style.width = '100%';
    outer.appendChild(inner);
    widthWithScroll = inner.offsetWidth;

    // Remove divs
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
  }
  function _isMobile() {
    var largeurEcran = $(window).width();
    if (largeurEcran < 768 - getScrollbarWidth()) {
      return true;
    } else {
      return false;
    }
  }
  function _isTablet() {
    var largeurEcran = $(window).width();
    if (largeurEcran < 1140 - getScrollbarWidth()) {
      return true;
    } else {
      return false;
    }
  }

  //empeche le retour en haut de page avec lien #
  $('a').click(function (event) {
    if ($(this).attr('href') == '#') {
      event.preventDefault();
    }
  });

  // Scroll to id
  function scrollToID(idZone, decalage) {
    if (!decalage) {
      decalage = 0;
    }
    $('html, body').animate({
      scrollTop: $(idZone).offset().top - decalage
    }, 1000, 'easeInOutCubic');
  }
  $('.navigation-scroll-ancre a[href^="#"]').click(function (event) {
    event.preventDefault();
    var hRef = $(this).attr('href');
    var idZone = hRef;
    var decalage = 0;
    if (hRef.indexOf('?') > -1) {
      idZone = hRef.split('?')[0];
      decalage = hRef.split('?')[1];
    }
    scrollToID(idZone, decalage);
  });
  $('.lien-scroll-ancre').click(function (event) {
    if ($(this).attr('href').match(/^#/)) {
      event.preventDefault();
      var idZone = $(this).attr('href');
      scrollToID(idZone);
    }
  });
  $(window).on('load scroll', function () {
    if ($('.navigation-scroll-ancre').length > 0) {
      $('.navigation-scroll-ancre a[href^="#"]').each(function () {
        var self = $(this);
        var zoneLink = self.attr('href');
        if (zoneLink.indexOf('?') > -1) {
          zoneLink = zoneLink.split('?')[0];
        }
        if ($(zoneLink).offset().top < window.pageYOffset + $('header').outerHeight() + $('#section-nav').outerHeight() + 10 && $(zoneLink).offset().top + $(zoneLink).outerHeight() > window.pageYOffset + $('header').outerHeight() + $('#section-nav').outerHeight() + 10) {
          self.addClass('nav-scroll-active');
        } else {
          self.removeClass('nav-scroll-active');
          self.blur();
        }
      });
    }
  });

  //Pour classe commune .matchHeight
  $('.match-height').matchHeight();
  $('.match-min-height').matchHeight({
    property: 'min-height'
  });
  //Pour classe image description bande noire
  $('.description-bande-noire .image-description').matchHeight();
  $(window).on('load resize', function () {
    //Pour classe commune navigation-sticky
    if ($('.navigation-sticky').length > 0) {
      var _hauteurOriginale = $('.navigation-sticky').offset().top;
      if (_isTablet() == false) {
        makeSticky(_hauteurOriginale);
        $(window).on('scroll', function () {
          makeSticky(_hauteurOriginale);
        });
      }
    }

    //Pour classe commune zone-sticky. On ajoute la classe is-sticky si on dépasse dans le scroll l'élément ref-position-sticky. 
    if ($('.zone-sticky').length > 0) {
      var _hauteurRef = 0;
      if ($('.ref-position-sticky').length > 0) {
        _hauteurRef = $('.ref-position-sticky').offset().top + $('.ref-position-sticky').outerHeight();
      }
      makeZoneSticky(_hauteurRef);
      $(window).on('scroll', function () {
        makeZoneSticky(_hauteurRef);
      });
    }
  });
  function makeSticky(hauteurOriginale) {
    var scrollPosition = $(window).scrollTop();
    if (scrollPosition > hauteurOriginale) {
      $('.navigation-sticky').addClass('is-sticky');
    } else {
      $('.navigation-sticky').removeClass('is-sticky');
    }
  }
  function makeZoneSticky(hauteurRef) {
    var scrollPosition = $(window).scrollTop();
    if (scrollPosition > hauteurRef) {
      $('.zone-sticky').addClass('is-sticky');
    } else {
      $('.zone-sticky').removeClass('is-sticky');
    }
  }

  // Fonction pour Toggle le aria-expanded
  function changeAriaExpanded(cible) {
    if ($(cible).attr('aria-expanded') == 'false') {
      $(cible).attr('aria-expanded', 'true');
    } else {
      $(cible).attr('aria-expanded', 'false');
    }
  }

  //Dropdown commun
  $('.commun-dropdown-toggle').click(function () {
    changeAriaExpanded(this);
    $(this).parent().next('.commun-dropdown-content').stop().slideToggle(400, 'easeInOutCubic', function () {
      $(this).css('height', 'auto');
    });
    $(this).next('.commun-dropdown-content').stop().slideToggle(400, 'easeInOutCubic', function () {
      $(this).css('height', 'auto');
    });
    $(this).parent('.commun-dropdown-links').find($('.intitule1')).toggleClass('isNotVisible');
    $(this).parent('.commun-dropdown-links').find($('.intitule2')).toggleClass('isVisible');
  });

  //Dropdown blocs messages
  $('.commun-bloc-toggle .commun-dropdown-toggle').click(function () {
    $(this).parent('.commun-dropdown-links').prev('.bloc-toggle-text').children('*').not(':first').stop().slideToggle(0);
  });

  //Dropdown dans des tuiles
  $('.commun-dropdown-toggle-tuile').click(function () {
    changeAriaExpanded(this);
    $(this).find('.intitule1').toggleClass('isNotVisible');
    $(this).find('.intitule2').toggleClass('isVisible');
    $(this).find('span').toggleClass('icone-rotate');
    $(this).next('.commun-dropdown-content').stop().slideToggle(0, 'swing', function () {
      var hauteurTuile = $(this).parent('.tuile-contenu-interieur').outerHeight();
      console.log(hauteurTuile);
      $('.tuile-spacer').css('height', hauteurTuile);
    });
  });

  //Open zone
  $('.open-zone').click(function (event) {
    changeAriaExpanded(this);
    event.preventDefault();
    var self = $(this);
    var afficherZone = self.attr('href');
    $(afficherZone).stop().slideToggle(400, 'swing');
    self.toggleClass('cta-actif');
  });

  //Liens de partage sur les réseaux sociaux
  liensSociaux.init();
  if ($('.video-rte').length != 0) {
    $('head').append('<link>');
    var css = $('head').children(':last');
    css.attr({
      rel: 'stylesheet',
      type: 'text/css',
      href: '/Content/commun/css/externes/video-js.css'
    });
    require(['lib-video']);
  }

  //Bugfix scroll (background fixed qui sautent) sur ie windows 10. A enlever quand IE marchera comme il faut
  if (navigator.userAgent.match(/Trident\/7\./)) {
    // if IE
    $('html').on('mousewheel', function () {
      // remove default behavior
      if (!$(this).hasClass('remodal-is-locked')) {
        event.preventDefault();
        //scroll without smoothing
        var wheelDelta = event.wheelDelta;
        var currentScrollPosition = window.pageYOffset;
        window.scrollTo(0, currentScrollPosition - wheelDelta);
      }
    });
  }
});